module.exports = __webpack_public_path__ + "static/media/game-interviewer14.8763056b.png";